export default __webpack_public_path__ + "static/media/track.4b20ba86.svg";